<template>
  <div class="container mt-5">
    <div class="row mb-5">
      <div class="col-8">
        <h3>Create team</h3>
      </div>
      <div class="col-4 text-right">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
      </div>
    </div>
    <div class="row">
      <div class="col-8 offset-2">
        <form @submit="submit">
          <div class="form-group">
            <label for="name">Team Name *</label>
            <input type="text" name="name" id="name" class="form-control" placeholder="ex: My Team" required v-model="form.name">
          </div>
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label for="teamcompetitions">Team Competitions <small><i class="text-muted">Optional</i></small></label>
                <v-select v-model="form.teamcompetitions" :options="competitions" multiple></v-select>
              </div>
            </div>
          </div>
          <hr>
          <label class="text-muted small">Team Competitions Overrides (JSON)</label>
          <div class="form-group" v-for="teamcompetition of form.teamcompetitions" :key="teamcompetition._id">
            <label>{{ teamcompetition.label }}</label>
            <editor v-model="teamcompetition.overrides" @init="editorInit" lang="json" theme="chrome" height="100"></editor>
          </div>
          <hr>
          <button type="submit" class="btn btn-primary btn-lg">Create</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { competitionService } from '../../services/competition'
import { teamService } from '../../services/team'
import vSelect from 'vue-select'

export default {
  name: 'TeamAdd',
  components: { datePicker, vSelect, editor: require('vue2-ace-editor') },
  data () {
    return {
      date: new Date(),
      options: {
        format: 'YY-MM-DD HH:mm',
        useCurrent: false
      },
      competitions: [],
      form: {
        name: '', teamcompetitions: null
      },
      selected: null
    }
  },
  mounted () {
    competitionService.getAll().then(result => {
      for (let competition of result.data.competitions) {
        this.competitions.push({label: competition.name, value: competition._id, overrides: '{}'})
      }
    })
  },
  methods: {
    submit (ev) {
      ev.preventDefault()
      teamService.insertOne({name: this.form.name}).then(teamRes => {
        teamService.linkTeamAndCompetitions(teamRes._id, this.form.teamcompetitions.map(tc => { return { _id: tc.value, overrides: tc.overrides } })).then(tcRes => {
          this.$router.push({ name: 'TeamShow', params: { id: teamRes._id } })
        })
      })
    },
    editorInit: function () {
      require('brace/ext/language_tools')
      require('brace/mode/html')
      require('brace/mode/json')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/snippets/json')
    }
  }
}
</script>
<style lang="scss">
div.dropdown-toggle::after{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Teams/TeamAdd.vue